import { each } from "lodash"

export const getTokenStatus = tokens => {
  let status = "ACTIVE"
  each(tokens, token => {
    if (token.status === "BROKEN") {
      status = "BROKEN"
    } else if (token.status === "REQUIRES_ATTENTION" && status !== "BROKEN") {
      status = "REQUIRES_ATTENTION"
    } else if (token.status === "NOT_CONNECTED" && status !== "BROKEN") {
      status = "NOT_CONNECTED"
    }
  })

  return status
}

export const formatAccount = (account, url) => {
  if (!account)
    return {
      value: 0,
      label: "Upsell account",
      platform: "",
      status: "active",
      url: "",
    }
  return {
    value: account.account_id,
    label: account.username,
    platform: account.platform,
    status:
      account.platform === "amazon" ? "active" : getTokenStatus(account.tokens),
    url: url
      .replace("{platform}", account.platform)
      .replace("{account}", account.account_id),
  }
}

export default { getTokenStatus, formatAccount }
